import React, { useEffect, useState } from 'react'
import EditIcon from 'assets/icon/icon-icon-options-edit.svg';
import EditHoverIcon from 'assets/icon/icon-icon-options-edit_hover.svg';
import HoverImage from 'react-hover-image/build';
import { Button, ButtonGroup, Col, FormGroup, Input, InputGroup, InputGroupText, Label, Row } from 'reactstrap';
import CancleIcon from 'assets/icon/icon-icon-options-not-eligible.svg';
import Calendar from 'assets/icon/calendar-icon.svg';
import SaveIcon from 'assets/icon/icon-icon-options-order-complete.svg';
import CellEditRender from 'components/reactStrapTable/components/CellEditRender';
import CancleHoverIcon from 'assets/icon/icon-icon-options-not-eligible-hover.svg';
import SaveHoverIcon from 'assets/icon/icon-icon-options-order-complete-hover.svg';
import { Field, Formik } from 'formik';
import ReactSelect from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useAxios from 'hooks/useAxios';
import useContextService from 'hooks/useContextService';
import {Option, LimitedChipsContainer } from 'components/Options';
import FormikSelectField from 'components/common/Fields/FormikSelectField';
import DatePicker from 'react-datepicker';
import ReactInputMask from 'react-input-mask';
import moment from 'moment';
import { dateFormate } from 'utils/columns';
import reseticon from "assets/icon/reset.svg";
import searchicon from "assets/icon/search.svg";





let hasDatePopupOpen = false;
//let role = ['SUPADM','SBPFADM']

let rowForEdit = {};
let updatedFields = {};
let coveredEntityError = "Covered Entity is a required field";
let accumulationError = "Accumulator is a required field";
let reportError = "";
const mapStatusOpt = [
    { id: 'Active', label: 'Active' },

  ];
  const dateRangeOption = [
    { id: '1', label: 'Current Month' },
    { id: '2', label: 'Last Month' },
    { id: '3', label: 'Last 30 Days' },
    { id: '4', label: 'Last 90 Days' },
    { id: '5', label: 'Last 180 Days' },
    { id: '6', label: 'Last 365 Days' },
    { id: '7', label: 'Custom' }
];
const reportptions = [
    { id: 'utilizationData', label: 'Utilization Data' },
    // { id: 'utilizationerror', label: 'Utilization Error Report' },
    { id: 'Drupspendbyaccount', label: 'Drug Spend By Account' },
    { id: 'Wacimpact', label: 'WAC Impact Report' },

 
];
const acunttypeptions = [
    { id: 1000, label: 'All' },
    { id: 1001, label: '340B' },
    { id: 1002, label: 'GPO' },
    { id: 1003, label: 'WAC' },
    { id: 1004, label: 'Pending' },
    // { id: 1005, label: 'Reason' },
 
];
const DateRangeTypeList = [{ code: 'Current Month', RangeTypeList: 'Current Month', Id: 1 }, { code: 'Last Month', RangeTypeList: 'Last Month', Id: 2 }, { code: 'Last 30 Days', RangeTypeList: 'Last 30 Days', Id: 3 }, { code: 'Last 90 Days', RangeTypeList: 'Last 90 Days', Id: 4 }, { code: 'Last 180 Days', RangeTypeList: 'Last 180 Days', Id: 5 }, { code: 'Last 180 Days', RangeTypeList: 'Last 360 Days', Id: 6 }, { code: 'Custom', RangeTypeList: 'Custom', Id: 7 }];
const statusTypesOpt = [{ Code: 'All', StatusType: 'All', Id: 0 }, { Code: 'INV', StatusType: 'Invoiced', Id: 1 }, { Code: 'NINV', StatusType: 'Non-Invoiced', Id: 2 }]
let coveredEntitiesData = [];
let accumulationData = [];
const SearchContainer = (props) => {
    const {
        orgId,
        onSearch,
        onreset,
        setSummeryData,
        setDetailsData,
        setTotalItem } = props;


    const [data, setData] = useState([]);
    const [showDetails, setShowDetails] = useState(true)
    const [activeButton, setActiveButton] = useState("All");
    const [isSubmited, serIsSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [hasACCSelected, setACCSelected] = useState(true);
    const [hasCESelected, setCESelected] = useState(true);
    const [isStartDate, setIsStartDate] = useState(null);
    const [isEndDate, setIsEndDate] = useState(null);
    const [dateRangeValue, setDateRangeValue] = useState(1);
    const [err, setError] = useState('');
    const [report,setReport] = useState('');
    const [acccountype,setAccountype] = useState('All');
    const [userRoles, setUserRoles] = useState([]);
    const [statusTypeSelected,setStatusTypeSelected] = useState(0)
    //const[onreset,setOnREset]= useState(false);
    const [selectedCEOption, setCEOptionSelected] = useState({
        optionCESelected: "-1",
    });
    const [selectedACCOption, setOptionACCSelected] = useState({
        optionACCSelected: "-1",
    });
    const { token_type, access_token, profile } =
    JSON.parse(localStorage.getItem('pharmaforce')) || {};
    const { sub,roles } = profile || {};
    const {
        states: { sbreports },
        setStates,
        resetStates,
    } = useContextService();
    const {search, coveredEntities, searchTerms, accumulations } = sbreports;
    
    let {
        startDate,
        endDate,
        accumulationIDs,
    } = searchTerms;
    const API = useAxios();


    useEffect(() => {
        setDateRangeValue(1);
        setReport('');
         setAccountype('');
         accumulationError = "";
        setCESelected(true);
        setACCSelected(true);
        coveredEntitiesData = [];
        accumulationData = [];
        sbreports.searchTerms.coveredEntityIDs = [];
        sbreports.searchTerms.accumulationIDs = {}
        sbreports.accumulations = [];
        updateStates(sbreports);
        setCEOptionSelected({ optionCESelected: '-1' });
        setOptionACCSelected({ optionACCSelected: '-1' });
        fetchCoveredEntities();

        if(Array.isArray(roles))
        {
            setUserRoles(roles);
        }
        else
        {
            var obj = [];
            obj.push(roles);
            setUserRoles(obj);
        }
    }, [orgId]);
    const updateStates = (sbreports) => {
        setStates("sbreports", sbreports);
    };
  
    const handleDateClick = (id) => {
        if (hasDatePopupOpen) {
            hasDatePopupOpen = false;
            return;
        }
        const calendarButton = document.getElementById(id);
        if (calendarButton) {
            calendarButton.click();
            hasDatePopupOpen = true;
        }
    };
    const fetchCoveredEntities = async () => {
        //let { organizationID } = orgId;
        if (typeof orgId !== "undefined" && orgId !== null) {
            coveredEntitiesData = [];
            sbreports.searchTerms.coveredEntityIDs = [];
            updateStates(sbreports);

            let selectedOrgId = orgId.organizationID;

            setLoading(false);
            try {
                const { data } = await API.get(`SBConfig/coveredentity/list/${selectedOrgId}`, {
                    hasDefaultURL: true,
                });
                setLoading(false);
                if (data) {
                    for (var x in data) {
                        coveredEntitiesData.push({ "value": data[x].coveredEntityID, "label": data[x].coveredEntityName });
                    }
                    console.log(data, "Data");
                    sbreports.coveredEntities = data;

                    if (coveredEntitiesData.length == 1) {
                        var ceData = [];
                        ceData.push(coveredEntitiesData[0])
                        sbreports.searchTerms.coveredEntityIDs = ceData;
                        window.selectedCoveredEntittyId = ceData;
                    }
                    if(window.selectedCoveredEntittyId.length > 0){
                        sbreports.searchTerms.coveredEntityIDs = window.selectedCoveredEntittyId;
                    }

                    updateStates(sbreports);
                    if (sbreports.searchTerms.coveredEntityIDs) {

                        var ceSelected = [];
                        ceSelected.optionCESelected = [];
                        for (var x in sbreports.searchTerms
                            .coveredEntityIDs) {
                            ceSelected.optionCESelected.push(
                                sbreports.searchTerms.coveredEntityIDs[x]
                            );
                        }
                        setCEOptionSelected(ceSelected);
                        let ceIds = sbreports.searchTerms.coveredEntityIDs.map(item => item["value"]);
                        fetchAccumulatorName(ceIds);
                    }

                }
            }
            catch (err) {
                setLoading(false);
            }
        }

    };



    

    // const handleEndDate = (endDate) => {
    //     debugger;
    //     let enDate = dateFormate(endDate);
    //     setIsEndDate(enDate);
    //     sbreports.searchTerms.endDate = moment(enDate).format("MM/DD/YYYY");
    //     if (startDate && moment(startDate).isAfter(enDate)) {
    //         setIsEndDate(null);
    //         sbreports.searchTerms.startDate = null;
    //     }
    //      updateStates(sbreports);
    // };
// const handleStartDate = (startDate) => {
//   debugger;
//   setError("");
//   let stDate = dateFormate(startDate);
//   setIsStartDate(stDate);
//   sbreports.searchTerms.startDate = moment(stDate).format("MM/DD/YYYY");
//   updateStates(sbreports);
// };
const handleStatusType = ({ target: { value }}) =>{
    debugger;
    setStatusTypeSelected(value)
    sbreports.searchTerms.statusTypeSelected = value
}
const handleStartDate = (startDate) =>{
    if(!startDate){
        setIsStartDate(null);
        sbreports.searchTerms.startDate = null;
        updateStates(sbreports);
        return;
    }
    let stDate = dateFormate(startDate);
    setIsStartDate(stDate);
    sbreports.searchTerms.startDate = moment(stDate).format("MM/DD/YYYY");
    updateStates(sbreports);
}
const handleEndDate = (endDate) => {
  debugger;

  if (!endDate) {
    setIsEndDate(null);
    sbreports.searchTerms.endDate = null;
    updateStates(sbreports);
    return;
  }

  let enDate = dateFormate(endDate); 
  setIsEndDate(enDate);
  sbreports.searchTerms.endDate = moment(enDate).format("MM/DD/YYYY");

  if (startDate && moment(startDate).isAfter(enDate)) {
    setIsEndDate(null);
    sbreports.searchTerms.startDate = null;
  }

  updateStates(sbreports);
};
    // const handleStartDateRaw = (e) => {
    //     debugger;
    //     var val = e.target.value;
    //     var dt = moment(val, "MM/DD/YYYY", true);
    //     var isValid = dt.isValid();
    //     if (isValid == false && sbreports.searchTerms.startDate !== null) {
    //         sbreports.searchTerms.startDate = null;
    //         setIsStartDate(null);
    //         updateStates(sbreports);

    //     }

    //     if (isValid) {
    //         const newDate = new Date(e.target.value);
    //         handleStartDate(newDate);
    //     }
    // }

    // const handleEndDateRaw = (e) => {
        
    //     // var valdt = new Date(endDate)
    //     var val = e.target.value;
    //     var dt = moment(val, "MM/DD/YYYY", true);
    //     var isValid = dt.isValid();
    //     if (isValid == false && sbreports.searchTerms.endDate !== null && val == '__/__/____') {
    //         sbreports.searchTerms.endDate = null;
    //         setIsEndDate(null)
    //         updateStates(sbreports);
    //     }

    //     if (isValid) {
    //         const newDate = new Date(e.target.value);
    //         handleEndDate(newDate);
    //     }
    // }
    const handleCoverdEntityChange = (selected, setFieldValue, entity) => {
       // let selected = [selectedces == null ? []: selectedces]
        
        if (selected) {
            window.selectedCoveredEntittyId = selected;
            window.selectedAccumulatorId = [];
            accumulationData = [];
            // setSelectedNdc('');
            sbreports.searchTerms.accumulationIDs = {};
            setCESelected(true);
            setCEOptionSelected({
                optionCESelected: selected.value
            });
            let val = selected.value;
            sbreports.coveredEntities = selected;
           // setFieldValue('coveredEntityIDs', selected);
            sbreports.searchTerms.coveredEntityIDs = selected;
            sbreports.search.pageSize = 10;
            if (Array.isArray(sbreports.searchTerms.coveredEntityIDs)) {
                accumulationIDs = {};
                sbreports.searchTerms.accumulationIDs = {};
            }
            let ceIds = sbreports.searchTerms.coveredEntityIDs.map(item => item["value"]);
            //sbreports.searchTerms.coveredEntityIDs = ceIds;
            updateStates(sbreports);
            fetchAccumulatorName(ceIds);
            setOptionACCSelected({ optionACCSelected: '-1' });
        }
        else {
           // setFieldValue('coveredEntityIDs', {});
            accumulationData = [];
            sbreports.coveredEntities = [];
            sbreports.searchTerms.coveredEntityIDs = {};
            sbreports.searchTerms.accumulationIDs = {};
            setCESelected(false);
            setACCSelected(false);
        }
        updateStates(sbreports);
    };
    const fetchAccumulatorName = async (coveredEntityIDs) => {
      
        if (coveredEntityIDs !== undefined && coveredEntityIDs.length > 0) {
            try {
                accumulationData = [];
                const payload = {};
                payload.CEIDS = coveredEntityIDs;
               // payload.AccumulatorEntityList = coveredEntityIDs;
                let AccumulatorEntityList = [payload.AccumulatorEntityList]
                const result = await API.post(`SBConfig/coveredentity/acclistall`,payload,
                    {
                        hasDefaultURL: true,
                    }
                );
                if (result) {
                    let accumulator = []
                    accumulator = result.data;
                    for (var x in accumulator) {
                        accumulationData.push({ "value": accumulator[x].accumulatorID, "label": accumulator[x].ceName });
                    }
                   
                    if (accumulationData.length == 1) {
                        var AccData = [];
                        AccData.push(accumulationData[0])
                        sbreports.searchTerms.accumulationIDs = AccData;
                        handleAccumulatorname(accumulationData[0]);
                                    
                      } 
                    //   else if (window.selectedAccumulatorId.length > 0) {
                    //     sbreports.searchTerms.accumulationIDs =
                    //       window.selectedAccumulatorId;
                    //       handleAccumulatorname(window.selectedAccumulatorId[0]);
                    //   }
                    sbreports.accumulations = result.data;
                    updateStates(sbreports);
                    // if (accumulationIDs.length > 0) {
                    //     var accumulatorSelected = {};
                    //     accumulatorSelected.optionACCSelected = [];
                    //     for (var x in accumulationIDs) {
                    //         accumulatorSelected.optionACCSelected.push(accumulationIDs[x]);
                    //     }
                    //     setOptionACCSelected({ accumulatorSelected});
                    // }
                }
            } catch (error) {
                console.log(error.message);
            }
        }
    };
    const handleAccumulatorname = (selectedacs, setFieldValue, ac) => {
      
      //let selected = [selectedacs == null ? [] : selectedacs]
      let selected = Array.isArray(selectedacs) ? selectedacs : [selectedacs];
      window.selectedAccumulatorId = selected;
        if (selected) {
            setACCSelected(true);
            setOptionACCSelected({
                optionACCSelected: selected
            })
            //   let val = selected.value;
            //   setFieldValue('accumulatorID', val);
            //   setFieldValue('accumulationIDs', selected);
            sbreports.searchTerms.accumulationIDs = selected;
        }
        else {
            setACCSelected(true);
            //   setFieldValue('accumulationIDs', {});
            accumulationData = [];
            sbreports.coveredEntities = [];
            sbreports.searchTerms.accumulationIDs = {};
            sbreports.searchTerms.coveredEntityIDs = {};
            setCESelected(false);
        }
        updateStates(sbreports);
    };

    const renderEditButton = () => {
        // if (hasPermission('EDT'))
        return <Button
            className='text-primary p-0 text-decoration-none'
            color='link'
            onClick={() => ""}
            title='Edit Covered Entity'

        >
            <HoverImage src={EditIcon}
                hoverSrc={EditHoverIcon}
                alt='' />
        </Button>
    }
    const cellRenderEdit = (rowData) => {

        if (rowData.isEdit) {
            return (
                <div className='d-flex align-items-center'>
                    <Button
                        className='text-primary p-0 text-decoration-none'
                        color='link'
                        onClick={savePanelUpdateRow}
                    >
                        <HoverImage
                            key='SaveIcon'
                            src={SaveIcon}
                            hoverSrc={SaveHoverIcon}
                            alt=''
                        />
                    </Button>
                    <Button
                        className='text-primary p-0 text-decoration-none'
                        color='link'
                        onClick={() => editRow(rowData, false)}
                    >
                        <HoverImage
                            key='CancelIcon'
                            src={CancleIcon}
                            hoverSrc={CancleHoverIcon}
                            alt=''
                        />
                    </Button>
                </div>
            );
        } else {

            return (
                <div className='d-flex align-items-center'>
                    {renderEditLButton1(rowData)}

                </div>
            );
        }
    };
    const renderEditLButton1 = (rowData) => {
        // if (hasPermission('EPLS'))
        return <Button
            className='text-primary p-0 text-decoration-none'
            color='link'

            onClick={() => editRow(rowData)}
            title='Edit'


        >
            <HoverImage src={EditIcon}
                hoverSrc={EditHoverIcon}
                alt='' />
        </Button>
    }
    const editRow = (rowData, isEdit = true) => {

        let tempData = [...data];
        tempData = tempData.map((row) => {
            row.isEdit = false;
            if (row.ceServiceLocationID === rowData?.ceServiceLocationID && isEdit) {
                row.isEdit = isEdit;
                rowForEdit = row;
            }
            return row;
        });
        // setTouched('');
        // setSelectedStatus('');
        updatedFields = {};
        //  tableDataBackup = tempData;
        setData(tempData);
    };
    const savePanelUpdateRow = async () => {
        console.log("")
    };
    const updateRowValue = (value, col) => {

        const tempRow = { ...rowForEdit };
        tempRow[col] = value;
        rowForEdit = tempRow;
    };
    const formatter = (row, col, formatterType, alwaysEditableCheckbox) => {

        return (
            <CellEditRender
                row={row}
                col={col}
                formatterType={formatterType}
                onChange={updateRowValue}
                alwaysEditableCheckbox={alwaysEditableCheckbox}
            />
        );
    };
    const handleDateRangeChange = ({ target: { value } }, setFieldValue) => {

        if (value) {
            
            const statusID = parseInt(value) - 1;
            const findObj = DateRangeTypeList[statusID];
            // setFieldValue('dateRange', value)
            sbreports.dateRange = findObj.Id;
            sbreports.dateRangeID = findObj.Id;
            setDateRangeValue(findObj.Id);
            setIsStartDate(null);
            setIsEndDate(null);
            setError('');
            sbreports.searchTerms.dateRangeID = findObj.Id;
            sbreports.searchTerms.startDate = '';
            sbreports.searchTerms.endDate = '';
            updateStates(sbreports);
            // setFieldValue('isStartDate', '');
            // setFieldValue('isEndDate', '');
        } else {
            // setFieldValue('dateRange', '')
            sbreports.dateRange = {};
            sbreports.dateRangeID = null;
            // sbreports(1);
            setError('');

        }
    }
    const handelAdd = () => {
        setShowDetails(false)
    }
    const handelCancel = () => {
        serIsSubmitted(false);
        setCESelected(true);
        setACCSelected(true);
        setData([]);
        onreset(true);
        reportError = '';
        setError("");
        accumulationData=[];
        setDateRangeValue(1)
        window.selectedCoveredEntittyId = "";
        window.selectedAccumulatorId = "";
        setCEOptionSelected({ optionCESelected: "-1" });
        setOptionACCSelected({ optionACCSelected: "-1" });
        sbreports.searchTerms.coveredEntityIDs = {};
        sbreports.searchTerms.accumulationIDs = {};
        sbreports.searchTerms.dateRangeID = {};
        sbreports.searchTerms.acunttype = '';
        sbreports.searchTerms.startDate = '';
        sbreports.searchTerms.endDate = '';
        sbreports.searchTerms.report = '';
        setStatusTypeSelected(0);
        searchTerms.dateRange = {};
        sbreports.dateRange = {};
        sbreports.dateRangeID = null;
        setAccountype('');
        setReport('');
        updateStates(sbreports);
        resetStates("sbreports");
    //await reset()
    }
    useEffect(() => {

    }, [showDetails])
    const handleMouseLeave = () => {
        hasDatePopupOpen = false;
    };

   
    const validations= (ceIDs,acIDs,setSubmitting)=>{
        if (ceIDs.length == 0) {
            setCESelected(false);
            if (acIDs.length == 0) {
                setACCSelected(false);
            }
            return setSubmitting(false);
        }
        if(ceIDs.length > 0 && acIDs.length == 0){
            setACCSelected(false);
            return setSubmitting(false);
        }
    }
   
    const handleButtonClick = (button) => {
        setActiveButton(button);
    };{}
    const handleSubmit = async (val, actions) => {
     debugger;
        let values = {};
        serIsSubmitted(true);
        const { setSubmitting } = actions;
        let acIDs = [];
        let ceIDs = [];
      
        for (var x in searchTerms.accumulationIDs) {
            var rw = searchTerms.accumulationIDs[x];
            acIDs.push(rw.value);
        }
        for (var x in searchTerms.coveredEntityIDs) {
            var rw = searchTerms.coveredEntityIDs[x];
            ceIDs.push(rw.value);
            
        }
        if(validations(ceIDs,acIDs,setSubmitting));
        if (report == '') {
            return reportError = 'Report Type is required'
        }
        if (ceIDs > [0]) values.coveredEntityIDs =ceIDs;
        if (acIDs > [0]) values.accumulationIDs = acIDs;
        if (startDate) values.startDate = startDate;
        if ((startDate == null || startDate == "") && sbreports.dateRange == 7) {
            return setError('Start date is required')
        }
        values.dateRangeID=  sbreports.searchTerms.dateRangeID;
        values.report = report;
        values.acccountype = acccountype;
        values.statusTypeSelected = statusTypeSelected
        if (endDate) values.endDate = endDate;

        sbreports.search.currentPage = 1;
        sbreports.search.orderBy = "modifiedDate";
        sbreports.search.order = "desc";
        updateStates(sbreports);
        await onSearch(values);
        setSubmitting(false);
      };
  
    const handleReport = (e) => {
        
        setReport(e.target.value);
        sbreports.searchTerms.report = e.target.value;
        sbreports.searchTerms.dateRangeID=1
        setAccountype('All')
        setDateRangeValue(1);
        setStatusTypeSelected(0);
        reportError = '';
        setDetailsData([]);
        setSummeryData([]);
        setTotalItem(0);
    }
    const handleAccounttype = (e) => {
        setAccountype(e.target.value);
        sbreports.searchTerms.acunttype = e.target.value;
    }
     
    return (

        <div>

            <Formik
                initialValues={searchTerms}
                onSubmit={handleSubmit}
                // validationSchema={validationSchema}
                enableReinitialize={true}
                children={(props) => {
                    const { isSubmitting, handleSubmit, resetForm, setFieldValue, errors, touched } = props;
                    return (
                        <div >
                         <h6 className='f-16 text-primary font-weight-700'>Search Reports</h6>
                            <div >
                                <Row sm={5} className='d-flex' style={{}}>
                                    <Col md={3} lg={3} sm={6} xs={6}  >
                                        {' '}
                                        <FormGroup className='ce-reports'>
                                            <Label for='coveredentity'>Covered Entity</Label>
                                            <ReactSelect
                                                name='coveredentity'
                                                id='coveredentity'
                                                options={coveredEntitiesData}
                                                isMulti
                                                closeMenuOnSelect={false}
                                                hideSelectedOptions={false}
                                                optionSelected={true}
                                                isClearable={true}
                                                components={{
                                                    Option, ValueContainer: LimitedChipsContainer,
                                                }}
                                                isSearchable="true"
                                                onChange={(value, cp) =>
                                                    handleCoverdEntityChange(value, setFieldValue, cp)}
                                                value={selectedCEOption.optionCESelected}
                                                className='claim_info required'
                                                maxMenuHeight={220}
                                                  styles={{
                                                menu: (provided) => ({
                                                    ...provided,
                                                    zIndex: 99,
                                                }),
                                                option: (provided) => ({
                                                    ...provided,
                                                    display: 'flex',
                                                    alignItems: 'flex-start',
                                                })
                                                }}
                                            />
                                              {!hasCESelected ? (
                                              <div className="text-danger f-12 position-absolute">
                                                {coveredEntityError}
                                              </div>
                                            ) : null}
                                        </FormGroup>
                                    </Col>
                                    <Col md={3} lg={3} sm={6} xs={6}  >
                                        {' '}
                                        <FormGroup className='ce-reports'>
                                            <Label for='accumulator'>Accumulator</Label>
                                            <ReactSelect
                                                name='accumulatorID'
                                                id='accumulationIDs'
                                                options={accumulationData}
                                                //isDisabled = {accumulationData.length==1}
                                                isMulti
                                                closeMenuOnSelect={false}
                                                hideSelectedOptions={false}
                                                optionSelected={true}
                                                isClearable={true}
                                                components={{
                                                    Option, ValueContainer: LimitedChipsContainer
                                                }}
                                                value={
                                                    selectedACCOption.optionACCSelected
                                                }
                                                isSearchable="true"
                                                onChange={(value, ac) =>
                                                    handleAccumulatorname(
                                                        value,
                                                        setFieldValue, ac
                                                    )
                                                }

                                               className='claim_info required'
                                                maxMenuHeight={220}
                                                // styles={{
                                                //     menu: (provided) => ({
                                                //         ...provided,
                                                //         zIndex: 99,
                                                //     }),
                                                // }}
                                                 styles={{
                                                menu: (provided) => ({
                                                    ...provided,
                                                    zIndex: 99,
                                                }),
                                                option: (provided) => ({
                                                    ...provided,
                                                    display: 'flex',
                                                    alignItems: 'flex-start',
                                                })
                                                }}
                                            />
                                          {(!hasACCSelected && isSubmited) ||
                                (hasCESelected &&
                                  isSubmited &&
                                  selectedACCOption.optionACCSelected == "-1") ? (
                                  <div className="text-danger f-12 position-absolute">
                                    {accumulationError}
                                  </div>
                                ) : null}
                                        </FormGroup>
                                    </Col>
                                   

                                </Row>
                                <Row>
                                <h6 style={{color: "#702c62",fontWeight:"700",fontSize:"16px"}}>Report Type Data</h6>
                                </Row>
                                <Row>
                                    <Col md={2}>
                                    <FormGroup>
                                            <Label >Report</Label>
                                            <Input
                                              className='required'
                                                id="mappedstatus"
                                                name="mappedstatus"
                                                type='select'
                                                value={report}
                                               onChange={handleReport}
                                            >
                                                   <option>--select--</option>
                                                {reportptions.map((status) => {
                                                    const { id, label } = status;
                                                    return (
                                                        <option key={id} value={id} hidden={label == 'WAC Impact Report' && !(userRoles.includes('SBPFADM') || userRoles.includes('SUPADM')) }>
                                                            {label}
                                                        </option>
                                                    );
                                                })}
                                            </Input>
                                            { reportError != ''? (
                                  <div className="text-danger f-12 position-absolute">
                                    {reportError}
                                  </div>
                                ) : ''}
                                        </FormGroup>
                                    </Col>
                                    <Col md={2} sm={3} xs={6} hidden={report != 'Drupspendbyaccount'}>
                                    <FormGroup >
                                        <Label for='statusType'>Status Type</Label>
                                        <Input
                                        name="statusType"
                                        type="select"
                                        autoComplete="off"
                                        value={statusTypeSelected}
                                        onChange={(val) => handleStatusType(val, setFieldValue)}
                                        >
                                        {statusTypesOpt.map(({ Id, StatusType }) => (
                                            <option key={Id} value={Id}>
                                            {StatusType}
                                            </option>
                                        ))}
                                        </Input>

                                    </FormGroup>
                                    </Col>
                                    <Col md={2}>
                                    <FormGroup>
                                            <Label >Account Type</Label>
                                            <Input
                                            //defaultValue={'All'}
                                              //className='required'
                                                id="accountype"
                                                name="accountype"
                                                type='select'
                                                value={acccountype}
                                              onChange={handleAccounttype}
                                            >
                                                {acunttypeptions.filter((status) => report !== 'Drupspendbyaccount' || (status.label !== 'Pending' && status.label !== 'Reason')).map((status) =>  {
                                                    const { id, label } = status;
                                                    return (
                                                        <option key={id} value={label}>
                                                            {label}
                                                        </option>
                                                    );
                                                })}
                                            </Input>
                                        </FormGroup>
                                    </Col>
                                    <Col md={2}>
                                    <FormGroup>
                                    <Label for="dateRange">Date Range</Label>
                                    <Field
                                        id="dateRange"
                                        name="dateRange"
                                        className="requiredS"
                                        type="text"
                                        defaultoption='--Select--'

                                        
                                        component={FormikSelectField}
                                        options={dateRangeOption}
                                        value={dateRangeValue}
                                        onChange={(val) => handleDateRangeChange(val, setFieldValue)}
                                        keys={{
                                            id: "id",
                                            label: "label",
                                        }}
                                    />
                                </FormGroup>
                                    </Col>
                                    <Col md={4}>
                                    <Row>
                                    <Col className='required-date'>
                                        <FormGroup hidden={dateRangeValue != '7'}>
                                            <Label>Start Date</Label>
                                            <InputGroup onMouseLeave={handleMouseLeave}>
                                                <DatePicker
                                                    id='isStartDate'
                                                    name='isStartDate'
                                                    selected={startDate}
                                                    onChange={ handleStartDate}
                                                    //onChangeRaw={handleStartDateRaw}
                                                    dateFormat="MM/dd/yyyy"
                                                    placeholderText='Select a date'
                                                    autoComplete='off'
                                                     isClearable
                                                     maxDate={isEndDate || new Date()}
                                                    customInput={
                                                        <ReactInputMask mask="99/99/9999"
                                                            value={isStartDate}
                                                        // maskChar=''
                                                        />
                                                    }
                                                />
                                                <InputGroupText
                                                    onClick={() => handleDateClick('isStartDate')}
                                                >
                                                    <img src={Calendar} alt='' />
                                                </InputGroupText>
                                            </InputGroup>
                                        </FormGroup>
                                        {err && <div className="text-danger font-size-12" >{err}</div>}

                                    </Col>

                                    <Col xs='auto' className='pt-3 mt-3'>
                                        <Label className='mt-1'> </Label>
                                    </Col>
                                    <Col className='purchase-date'>
                                        <FormGroup hidden={dateRangeValue != '7'}>
                                            <Label>End Date</Label>
                                            <InputGroup onMouseLeave={handleMouseLeave}>
                                                <DatePicker
                                                    id='endDate'
                                                    name='endDate'
                                                    selected={endDate}
                                                    onChange={(e) => { handleEndDate(e) }}
                                                   //onChangeRaw={handleEndDateRaw}
                                                    dateFormat="MM/dd/yyyy"
                                                    maxDate={new Date()}
                                                    minDate={isStartDate ? isStartDate : null}
                                                    isClearable
                                                    placeholderText='Select a date'
                                                    autoComplete='off'
                                                    customInput={
                                                        <ReactInputMask mask="99/99/9999"
                                                            value={endDate}
                                                        // maskChar=''
                                                        />
                                                    }
                                                    //maxDate={new Date()}
                                                />
                                                <InputGroupText
                                                    onClick={() => handleDateClick('endDate')}
                                                >
                                                    <img src={Calendar} alt='' />
                                                </InputGroupText>
                                            </InputGroup>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                    </Col>
                                 
                                    </Row>
                                <Row style={{display:"flex",justifyContent:"flex-end"}}>
                                <Col md="auto" >
                                        <Label>{""}</Label>
                                        <Button
                                       
                                            color="primary"
                                            className="search"
                                            onClick={handleSubmit}

                                        // disabled={!coveredEntityid}
                                        // hidden={!hasPermission("ADD")}
                                        >
                                            <span className="right_5">
                                                                <img src={searchicon} alt="" />
                                                              </span>{" "}
                                            Search
                                        </Button>
                                        <Button
                                            // hidden={isAddPermission}
                                            // disabled={isSubmitting}
                                            color="primary"
                                            className="reset"
                                            onClick={handelCancel}
                                        >
                                             <span className="right_5">
                                                                <img src={reseticon} alt="" />
                                                              </span>{" "}
                                            Reset
                                        </Button>
                                
                                    </Col>
                                </Row>
                            </div>
                            
                               
                            

                        </div>);
                }}></Formik>
          



        </div>
    )
}

export default SearchContainer
